import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { get, isNil } from 'lodash';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsPage from '../../components/EsmsPage';

import BacNetEthernetPanel from './BacNetEthernetPanel';
import BacNetIpPanel from './BacNetIpPanel';
import NiagaraPanel from './NiagaraPanel';

import * as BasAgentActions from '../../actions/basAgentActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './AgentNetworkPage.module.css';

class AgentNetworkPage extends Component {
    state = {
        driver:         'BacnetIP',
        driverDisabled: false
    }

    componentDidMount() {
        const { location, fetchBasAgent } = this.props;
        const queryValues = new URLSearchParams(location.search);

        if (!queryValues.has('basAgent')) {
            this.handleBasAgentsRoute();
            return;
        }

        fetchBasAgent(queryValues.get('basAgent'));

        if (this.props.selectedAgent) {
            this.autoSelectDriver();
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedAgent !== this.props.selectedAgent) {
            this.autoSelectDriver();
        }
    }

    autoSelectDriver = () => {
        const { selectedAgent } = this.props;

        const driver =
            get(selectedAgent, 'driverConfiguration[0].basType', null);

        if (driver === 'NotConfigured' || isNil(driver)) {
            return;
        }

        this.setState({
            driver,
            driverDisabled: true
        });
    }

    stripFileTypeHeader = file => {
        return file ? file.replace('data:application/octet-stream;base64,', '') : null;
    }

    handleIotHubRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub?company=${queryValues.get('company')}`);
    }

    handleBasAgentsRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub/basagents?company=${queryValues.get('company')}`);
    }

    handleSelectedAgentRoute = () => {
        const { history, location } = this.props;
        const queryValues = new URLSearchParams(location.search);

        history.push(`/iothub/basagents/manage?company=${queryValues.get('company')}&basAgent=${queryValues.get('basAgent')}`);
    }

    handleDriverSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleCancel = () => {
        this.handleSelectedAgentRoute();
    }

    handleSaveNetworkConfig = async config => {
        const { companyInfo, selectedAgent, updateBasAgent, isLoading } = this.props;
        const payload = {
            driverConfiguration: [config]
        };

        if (!isLoading) {
            this.props.toggleLoading(true);
            await updateBasAgent(companyInfo.companyId, selectedAgent.id, payload);
            this.props.toggleLoading(false);
        }
    }

    render() {
        const { selectedAgent, companyInfo, isLoading } = this.props;
        const { driverDisabled } = this.state;

        if (!selectedAgent) {
            return null;
        }

        return (
            <EsmsPage
                parents={[
                    companyInfo.companyName,
                    'BAS Agents',
                    selectedAgent.name
                ]}
                title="Network Configuration"
                handlers={[
                    this.handleIotHubRoute,
                    this.handleBasAgentsRoute,
                    this.handleSelectedAgentRoute
                ]}
            >
                <div className={classes.AgentNetworkPage}>
                    <div className={classes.pageActions}>
                        <FormControl className={classes.driverSelectFormControl}>
                            <InputLabel
                                htmlFor="driver-select"
                                classes={{
                                    focused: classes.cssFocused
                                }}
                            >
                                BAS System Driver
                            </InputLabel>
                            <Select
                                value={this.state.driver}
                                onChange={this.handleDriverSelectChange}
                                className={classes.driverSelect}
                                disabled={driverDisabled}
                                inputProps={{
                                    name: 'driver',
                                    id:   'driver-select'
                                }}
                            >
                                <MenuItem value="BacnetIP" className={classes.selectMenuItem}>BACnet-IP</MenuItem>
                                <MenuItem value="BacnetEthernet" className={classes.selectMenuItem}>BACnet-Ethernet</MenuItem>
                                <MenuItem value="Niagara" className={classes.selectMenuItem}>Tridium Niagara (oBIX)</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        {this.state.driver === 'BacnetIP' &&
                        <BacNetIpPanel
                            save={this.handleSaveNetworkConfig}
                            agent={selectedAgent}
                            clearErrors={this.props.clearErrors}
                            stripFileTypeHeader={this.stripFileTypeHeader}
                            isLoading={isLoading}
                        />
                        }
                        {this.state.driver === 'BacnetEthernet' &&
                        <BacNetEthernetPanel
                            save={this.handleSaveNetworkConfig}
                            agent={selectedAgent}
                            clearErrors={this.props.clearErrors}
                            stripFileTypeHeader={this.stripFileTypeHeader}
                            isLoading={isLoading}
                        />
                        }
                        {this.state.driver === 'Niagara' &&
                        <NiagaraPanel
                            save={this.handleSaveNetworkConfig}
                            agent={selectedAgent}
                            clearErrors={this.props.clearErrors}
                            isLoading={isLoading}
                        />
                        }
                    </div>
                </div>
            </EsmsPage>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        basAgents:     Object.values(basAgents),
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        isLoading:     state.ui.isLoading,
        selectedAgent
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BasAgentActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentNetworkPage));
